<template>
  <BasicBlock :title="$t('custom_fields.block.title')">
    <div class="f-grid f-col-1 f-gap-2">
      <CustomField
        :class="['fapi-form-custom-field', 'fapi-form-custom-field-' + index]"
        v-for="(customField, index) in formResource.custom_fields"
        v-bind:key="index + '-custom-field'"
        :customField="customField"
        @customFieldUpdated="$emit('customFieldUpdated', $event)"
        :singleColumn="singleColumn"
      >
      </CustomField>
    </div>
  </BasicBlock>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";
import CustomField from "@/components/Form/CustomFields/CustomField.vue";
import BasicBlock from "@/components/Form/BasicBlock.vue";
import FormResource from "@/module/Form/Resources/FormResource";
import TemplateSettings from "@/module/Form/Resources/TemplateSettings";

export default Vue.extend({
  name: "CustomFields",

  components: { BasicBlock, CustomField },

  props: {
    formResource: {
      type: Object as PropType<FormResource>,
      required: true,
    },
    templateSettings: {
      type: Object as PropType<TemplateSettings>,
      required: true,
    },
  },
  computed: {
    singleColumn(): boolean {
      return (
        this.templateSettings.container_settings.billing.layout.column ===
        "single"
      );
    },
  },
});
</script>

<style></style>
